import { AfterViewInit, Component, Input, ViewChild, ElementRef } from '@angular/core';
import { HttpClient } from '@angular/common/http';
declare var window:any;

@Component({
    selector: 'app-portal-video-with-description',
    templateUrl: './portal-video-with-description.component.html',
    styleUrls: ['./portal-video-with-description.component.scss']
})
export class PortalVideoWithDescriptionComponent implements AfterViewInit {
    @Input() data: any;
    @ViewChild('pageDataContainer') pageDataContainer!: ElementRef;
    constructor(private http: HttpClient) {}
    private readonly youtubeLinkRegex = /(?:youtube\.com\/\S*(?:(?:\/e(?:mbed))?\/|watch\?(?:\S*?&?v\=))|youtu\.be\/)([a-zA-Z0-9_-]{6,11})/;

    googleApiKey: string = "";
    videoUrl: string = "";
    videoCode: string | null = "";

    ngAfterViewInit() {
        this.videoUrl = this.data.videoLink;
        this.videoCode = this.extractCodeFromUrl(this.data.videoLink);
        window.youtubePopupHandler.init();
        window.bindCommonScript();
    }

    extractCodeFromUrl(url: string) {
        const match = url.match(this.youtubeLinkRegex);
        if (match && match[1]) {
            return match[1];
        }
        return null;
    }
}